// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__347ap","topBottomGutter":"Layout_topBottomGutter__1x5WN"};